import React from 'react';

const About = () => {
  const features = [
    {
      icon: '🔐',
      title: 'PGP Encryption',
      description: 'End-to-end encryption using OpenPGP. Your emails are encrypted before leaving your device and can only be decrypted by the intended recipient.'
    },
    {
      icon: '📧',
      title: 'Temp Mail Aliases',
      description: 'Create disposable email addresses that forward to your inbox. Protect your real email from spam and unwanted subscriptions.'
    },
    {
      icon: '⚡',
      title: 'Lightning Fast',
      description: 'Built on Cloudflare\'s global edge network. Your emails are sent and received with minimal latency, anywhere in the world.'
    },
    {
      icon: '🔒',
      title: 'Privacy First',
      description: 'We don\'t read your emails, sell your data, or show you ads. Your privacy is our business model.'
    },
    {
      icon: '🌍',
      title: 'Custom Domains',
      description: 'Use your own domain for a professional appearance. Enterprise plans support unlimited custom domains.'
    },
    {
      icon: '💻',
      title: 'API Access',
      description: 'Full REST API for developers. Automate email sending, manage aliases, and integrate with your applications.'
    }
  ];

  return (
    <div className="fade-in" style={{ maxWidth: '1000px', margin: '0 auto' }}>
      {/* Hero Section */}
      <div style={{ textAlign: 'center', marginBottom: '60px' }}>
        <h1 style={{ fontSize: '42px', fontWeight: '800', marginBottom: '20px' }}>
          About <span style={{ color: '#DC2626' }}>Addison</span>Mail
        </h1>
        <p style={{ fontSize: '18px', color: 'var(--text-muted)', maxWidth: '700px', margin: '0 auto', lineHeight: '1.7' }}>
          We're building the email service we always wanted: secure, private, and 
          feature-rich without compromising on usability.
        </p>
      </div>

      {/* Mission Section */}
      <div className="card" style={{ padding: '40px', marginBottom: '40px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '20px' }}>
          Our Mission
        </h2>
        <p style={{ fontSize: '16px', lineHeight: '1.8', color: 'var(--text-muted)' }}>
          In an age of surveillance capitalism and data breaches, email privacy shouldn't be 
          a luxury. Addison Mail was founded with a simple belief: everyone deserves secure 
          communication. We combine military-grade encryption with an intuitive interface, 
          proving that security and ease of use aren't mutually exclusive.
        </p>
      </div>

      {/* Features Grid */}
      <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '30px', textAlign: 'center' }}>
        What Makes Us Different
      </h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '24px',
        marginBottom: '60px'
      }}>
        {features.map((feature, index) => (
          <div key={index} className="card" style={{ padding: '28px' }}>
            <div style={{ fontSize: '40px', marginBottom: '16px' }}>{feature.icon}</div>
            <h3 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '12px' }}>
              {feature.title}
            </h3>
            <p style={{ fontSize: '14px', color: 'var(--text-muted)', lineHeight: '1.6' }}>
              {feature.description}
            </p>
          </div>
        ))}
      </div>

      {/* Stats Section */}
      <div className="card" style={{ padding: '40px', marginBottom: '40px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '30px', textAlign: 'center' }}>
          By The Numbers
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '30px',
          textAlign: 'center'
        }}>
          <div>
            <div style={{ fontSize: '36px', fontWeight: '800', color: '#DC2626' }}>50K+</div>
            <div style={{ color: 'var(--text-muted)', marginTop: '8px' }}>Active Users</div>
          </div>
          <div>
            <div style={{ fontSize: '36px', fontWeight: '800', color: '#DC2626' }}>1M+</div>
            <div style={{ color: 'var(--text-muted)', marginTop: '8px' }}>Emails Sent</div>
          </div>
          <div>
            <div style={{ fontSize: '36px', fontWeight: '800', color: '#DC2626' }}>99.9%</div>
            <div style={{ color: 'var(--text-muted)', marginTop: '8px' }}>Uptime</div>
          </div>
          <div>
            <div style={{ fontSize: '36px', fontWeight: '800', color: '#DC2626' }}>0</div>
            <div style={{ color: 'var(--text-muted)', marginTop: '8px' }}>Data Breaches</div>
          </div>
        </div>
      </div>

      {/* Team Section */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '20px' }}>
          Built By Addison Electronique
        </h2>
        <p style={{ fontSize: '16px', color: 'var(--text-muted)', maxWidth: '600px', margin: '0 auto' }}>
          Addison Electronique is a technology company focused on privacy-preserving 
          communication tools. We're a small team with big ambitions: to make privacy 
          the default, not the exception.
        </p>
      </div>
    </div>
  );
};

export default About;

